import styled, { css } from "styled-components";
import { Wrapper } from 'AppReact';

const CalendarWrapper = styled.div`
  ${({ displayState }) => css`
    width: ${displayState?.borderless ? '100%' : '294px'};
    padding: 25px;
    box-shadow: ${displayState?.borderless ? '' : '0px 1px 2px rgba(0, 0, 0, 0.08)'};
    border-radius: ${displayState?.borderRadius ?? '6px'};
    border: ${displayState?.borderless ? '' : '1px solid #E3E3E3'};
    background: #FFFFFF;
  `}
`;

export default Wrapper(CalendarWrapper);